// extracted by mini-css-extract-plugin
export default {"bottomFixButtonWrapper":"FixedBottomButton_bottomFixButtonWrapper__OVUKQ","showBackground":"FixedBottomButton_showBackground__-nN-U"};